import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';

// Login component for Google Sign-In - Modern two-column design
const LoginPage = () => {
  const { login } = useAuth();

  // Meta Pixel Code - Add as is
  useEffect(() => {
    // Execute the exact Meta Pixel code
    /* eslint-disable */
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('init', '853274407274111');
      window.fbq('track', 'PageView');
    }
    /* eslint-enable */
  }, []);

  // JSON-LD Schema for SEO
  const jsonLdSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://getphotoshoot.ai/#organization",
        "name": "Qressy Solutions Private Limited",
        "legalName": "Qressy Solutions Private Limited",
        "url": "https://getphotoshoot.ai",
        "logo": "https://getphotoshoot.ai/logobg.png",
        "sameAs": [
          "https://www.instagram.com/getphotoshoot.ai?igsh=N2Zham5oOHUzenli",
          "https://www.twitter.com",
          "https://www.youtube.com"
        ],
        "contactPoint": {
          "@type": "ContactPoint",
          "email": "success@getphotoshoot.ai",
          "contactType": "customer support"
        }
      },
      {
        "@type": "WebApplication",
        "@id": "https://getphotoshoot.ai/#webapp",
        "name": "Photoshoot AI",
        "alternateName": "getphotoshoot.ai",
        "url": "https://getphotoshoot.ai",
        "applicationCategory": "BusinessApplication",
        "operatingSystem": "Web Browser",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "INR",
          "description": "10 free credits included (worth ₹250) upon sign up",
          "availability": "https://schema.org/InStock"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "ratingCount": "500",
          "bestRating": "5",
          "worstRating": "1"
        },
        "description": "AI-powered jewelry photography platform that transforms jewelry photos into professional model presentations in seconds. No expensive photoshoots needed.",
        "provider": {
          "@id": "https://getphotoshoot.ai/#organization"
        },
        "applicationSubCategory": "Fashion Photography",
        "keywords": "jewelry photography, fashion photography, AI photography, jewelry photoshoot, fashion photoshoot, AI models, jewelry product photography",
        "featureList": [
          "AI Generated Models",
          "Real Human Integration",
          "Aesthetic Backgrounds",
          "Instant Results",
          "Professional Quality",
          "Multiple Styles",
          "HD Quality Output",
          "Fashion Photography"
        ]
      },
      {
        "@type": "Service",
        "@id": "https://getphotoshoot.ai/#service",
        "name": "AI-Powered Jewelry Photography",
        "description": "Transform your jewelry photos into stunning model presentations using AI. Place jewelry on professional AI-generated or real human models with aesthetic backgrounds.",
        "provider": {
          "@id": "https://getphotoshoot.ai/#organization"
        },
        "areaServed": "Worldwide",
        "serviceType": ["Jewelry Photography", "Fashion Photography"],
        "category": "Fashion & Jewelry Photography Services",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "INR",
          "description": "Start with 10 free credits (worth ₹250)",
          "priceSpecification": {
            "@type": "UnitPriceSpecification",
            "price": "25",
            "priceCurrency": "INR",
            "unitText": "credit"
          }
        }
      },
      {
        "@type": "WebPage",
        "@id": "https://getphotoshoot.ai/#webpage",
        "name": "Photoshoot AI - AI-Powered Jewelry Photography",
        "description": "Show your jewelry on professional models in minutes, not days. AI-powered jewelry photography platform trusted by 500+ retailers worldwide.",
        "url": "https://getphotoshoot.ai",
        "inLanguage": "en-US",
        "isPartOf": {
          "@id": "https://getphotoshoot.ai/#webapp"
        },
        "about": {
          "@id": "https://getphotoshoot.ai/#service"
        },
        "mainEntity": {
          "@id": "https://getphotoshoot.ai/#service"
        }
      },
      {
        "@type": "FAQPage",
        "@id": "https://getphotoshoot.ai/#faq",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "How does the AI photoshoot generation work?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Simply upload your raw jewelry image, choose your preferred style (AI model, real human, or aesthetic background), and our AI will generate a professional photoshoot in under 30 seconds."
            }
          },
          {
            "@type": "Question",
            "name": "What image formats do you support?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We support JPG, PNG, and WEBP formats. For best results, upload high-resolution images with good lighting and clear jewelry visibility."
            }
          },
          {
            "@type": "Question",
            "name": "How many credits do I get for free?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "New users receive 10 free credits (worth ₹250) upon signing up. This allows you to generate 5 professional images to test our service."
            }
          },
          {
            "@type": "Question",
            "name": "Can I download the generated images?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes! All generated images are available for immediate download in high resolution. You own the rights to use these images for your business."
            }
          },
          {
            "@type": "Question",
            "name": "Do credits expire?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "No, credits never expire."
            }
          }
        ]
      }
    ]
  };

  return (
    <div className="login-page">
      {/* Meta Pixel Code */}
      <noscript>
        <img 
          height="1" 
          width="1" 
          style={{ display: 'none' }}
          src="https://www.facebook.com/tr?id=853274407274111&ev=PageView&noscript=1"
          alt=""
        />
      </noscript>
      {/* End Meta Pixel Code */}

      {/* JSON-LD Schema for SEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdSchema) }}
      />
      <div className="login-layout">
        {/* Left Section - Promotional Content */}
        <div className="login-left">
          <div className="login-hero">
            <div className="hero-badge">
              <span className="badge-icon">🚀</span>
              <span>AI-Powered Jewelry Photography</span>
            </div>
            
            <h1 className="login-hero-title">
              Show your jewelry on professional models in <span className="highlight">minutes</span>, not days
            </h1>
            
            <p className="login-hero-subtitle">
              Transform your jewelry photos into stunning model presentations using AI. <strong>No expensive photoshoots. No long wait times.</strong> Just upload and get professional results instantly.
            </p>
            
            {/* Key Benefits */}
            <div className="login-benefits">
              <div className="benefit-item">
                <span className="benefit-icon">⚡</span>
                <div className="benefit-text">
                  <span className="benefit-title">Instant Results</span>
                  <span className="benefit-desc">Get professional photos in seconds</span>
                </div>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">💰</span>
                <div className="benefit-text">
                  <span className="benefit-title">Save 90% Costs</span>
                  <span className="benefit-desc">No expensive photoshoots needed</span>
                </div>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">✨</span>
                <div className="benefit-text">
                  <span className="benefit-title">Professional Quality</span>
                  <span className="benefit-desc">Studio-grade model presentations</span>
                </div>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">🎨</span>
                <div className="benefit-text">
                  <span className="benefit-title">Multiple Styles</span>
                  <span className="benefit-desc">Various poses and angles available</span>
                </div>
              </div>
            </div>

            {/* Social Proof */}
            <div className="login-social-proof">
              <div className="proof-stats">
                <div className="stat-item">
                  <div className="stat-number">10K+</div>
                  <div className="stat-label">Images Generated</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">500+</div>
                  <div className="stat-label">Happy Retailers</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">4.9★</div>
                  <div className="stat-label">Average Rating</div>
                </div>
              </div>
            </div>

            {/* Trusted By Section */}
            <div className="login-trusted">
              <p className="trusted-label">Trusted by jewelry retailers worldwide</p>
              <div className="trusted-logos">
                <div className="trusted-logo-item">
                  <span className="logo-text">E-commerce Stores</span>
                </div>
                <div className="trusted-logo-item">
                  <span className="logo-text">Jewelry Boutiques</span>
                </div>
                <div className="trusted-logo-item">
                  <span className="logo-text">Craft Artisans</span>
                </div>
                <div className="trusted-logo-item">
                  <span className="logo-text">Retail Chains</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Vertical Separator */}
        <div className="login-separator"></div>

        {/* Right Section - Login Form */}
        <div className="login-right">
          <div className="login-form-container">
            {/* Logo */}
            <div className="login-brand">
              <img src="/logobg.png" alt="getphotoshoot.ai logo" className="login-brand-icon" />
          </div>
          
          

            {/* Primary CTA - Most Prominent */}
            <div className="login-cta-primary">
              <button 
                className="login-btn login-btn-primary-cta"
                onClick={login}
              >
                <div className="btn-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24">
                    <path fill="white" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="white" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="white" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="white" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                </div>
                <div className="btn-text-wrapper">
                  <span className="btn-main-text">Start Creating Now</span>
                  <span className="btn-sub-text">Free with Google • No credit card needed</span>
                </div>
              </button>

                {/* Terms Acceptance */}
            <div className="login-terms-text">
              <p className="terms-text">
                By signing in, I accept all <Link to="/tos" className="terms-link">Terms and Conditions</Link>
              </p>
            </div>
              
              {/* Trust Signals */}
              <div className="login-trust-signals">
                <div className="trust-signal-item">
                  <span className="trust-check">✓</span>
                  <span>10 free credits included (worth ₹250)</span>
                </div>
                <div className="trust-signal-item">
                  <span className="trust-check">✓</span>
                  <span>No commitment required</span>
                </div>
                <div className="trust-signal-item">
                  <span className="trust-check">✓</span>
                  <span>Cancel anytime</span>
                </div>
              </div>
            </div>

            {/* Conversion-focused messaging */}
            <div className="login-urgency">
              <div className="urgency-badge">
                <span className="urgency-icon">🔥</span>
                <span className="urgency-text">Join 500+ retailers creating professional photos today</span>
              </div>
            </div>

            <p className="login-legal">
              Need help? <button className="legal-link" onClick={() => window.location.href = 'mailto:success@getphotoshoot.ai'}>Contact Support</button>
            </p>

            {/* Feature Highlights */}
            <div className="login-features">
              <div className="feature-item">
                <span className="feature-icon">🔒</span>
                <div className="feature-content">
                  <span className="feature-title">Secure & Private</span>
                  <span className="feature-desc">Your images are safe and encrypted</span>
                </div>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✓</span>
                <div className="feature-content">
                  <span className="feature-title">Professional Quality</span>
                  <span className="feature-desc">Studio-grade model photos</span>
                </div>
              </div>
              <div className="feature-item">
                <span className="feature-icon">⚡</span>
                <div className="feature-content">
                  <span className="feature-title">Instant Delivery</span>
                  <span className="feature-desc">Results in 30-60 seconds</span>
                </div>
              </div>
            </div>

          </div>

         
          
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
